import React, { Children, cloneElement, Component, Fragment, isValidElement } from 'react';
import { CSSTransition } from 'react-transition-group';
import { DocumentContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { getBestPosition } from '@philips-internal/oswald-ui-utils';
import PopoverContent from './popover-content.js';
import './popover.css';
class Popover extends Component {
    constructor() {
        super(...arguments);
        this.state = {};
        this.targetRef = (targetElement) => {
            this.setState({ targetElement: targetElement ?? undefined });
        };
        this.contentRef = (contentElement) => {
            this.setState({ contentElement: contentElement ?? undefined });
        };
        this.onContentResize = () => {
            this.forceUpdate();
        };
    }
    getContentWidth() {
        const { matchTargetWidth } = this.props;
        const { targetElement } = this.state;
        return matchTargetWidth && targetElement
            ? targetElement.offsetWidth
            : undefined;
    }
    renderTarget(target) {
        if (isValidElement(target)) {
            return cloneElement(target, { ref: this.targetRef });
        }
        return null;
    }
    renderContent(content) {
        if (!isValidElement(content)) {
            return null;
        }
        const { alignment, className, maxHeight, onClose, open, padding, placement, showArrow, targetRef, title, zIndex } = this.props;
        const { targetElement, contentElement } = this.state;
        const { window, document } = this.context;
        const position = getBestPosition({
            alignment,
            arrowSize: showArrow ? 12 : 0,
            guestElement: contentElement,
            hostElement: targetRef?.current ?? targetElement,
            offset: {
                bottom: 0,
                height: 0,
                left: 8,
                right: 0,
                top: 8,
                width: 0,
            },
            placement,
            window,
        });
        const element = cloneElement(content, {
            className,
            document,
            maxHeight,
            onClose,
            onResize: this.onContentResize,
            open,
            padding,
            placement: position.placement,
            position,
            ref: this.contentRef,
            showArrow,
            title,
            width: this.getContentWidth(),
            zIndex,
        });
        return (React.createElement(CSSTransition, { classNames: "popover__fade", in: open, timeout: 200, unmountOnExit: true }, element));
    }
    render() {
        const { children } = this.props;
        const validChildren = Children.toArray(children).filter(isValidElement);
        const content = validChildren.find(child => child.type === Popover.Content);
        const target = validChildren.find(child => child.type !== Popover.Content);
        return (React.createElement(Fragment, null,
            this.renderTarget(target ?? null),
            this.renderContent(content ?? null)));
    }
}
Popover.contextType = DocumentContext;
Popover.Content = PopoverContent;
Popover.defaultProps = {
    matchTargetWidth: false,
    open: false,
    showArrow: true,
};
export { Popover, };
export default Popover;
//# sourceMappingURL=popover.js.map